import React, { useState } from 'react';
import * as dateFns from 'date-fns';

//import Weather from './Weather';
import AddButton from '../../../AddButton/AddButton';
import CreatePracticeModal from '../../../CreatePracticeModal';

import './DayHeader.scss';
import { DayHeaderPropsType } from '../types';

const DayHeader = ({ date, numDay, showAddButton }: DayHeaderPropsType) => {
  const dayOfWeek = dateFns.format(new Date(date), 'EEE');
  const dayOfYear = dateFns.format(new Date(date), 'd');
  const [clickButton, setClickButton] = useState(false);
  const handleClickButton = () => {
    setClickButton(true);
  };
  const handleCloseButton = () => {
    setClickButton(false);
  };
  const modal = clickButton ?
    <CreatePracticeModal show={clickButton} handleClose={handleCloseButton} day={date} /> : null;
  return (
    <>
      {modal}
      <div
        className={`col day-view ${dateFns.isSameDay(date, new Date()) ? 'today' : ''} ${numDay === 6 ? 'last-day' : numDay === 0 ? 'first-day-header' : ''}`}>
        <div className="day-s">
          <h6>{dayOfWeek}</h6>
          <h4>{dayOfYear}</h4>
        </div>
        {/* {dailyWeather && <Weather weather={dailyWeather} id={dayOfYear}/>} */}
        {showAddButton && (dateFns.isFuture(date) || dateFns.isToday(date)) && (
          <AddButton display={true} day={date} handleClickButton={handleClickButton} />
        )}
      </div>
    </>
  );
};

export default DayHeader;
